module.exports = __webpack_public_path__ + "static/img/7-3.30ac72f6.jpg";